import React from 'react';
import { SimpleModal } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
// import useStyles from './styles';
import { useTranslation } from 'react-i18next';
// import { useStore } from 'src/stores';
import { GetForm } from './modalForm';
export const AssignPropertiesToPortfolioModal = observer(_ref => {
  let externalIsOpen = _ref.externalIsOpen,
    callback = _ref.callback,
    externalPortfolioItem = _ref.externalPortfolioItem,
    subTitle = _ref.subTitle,
    currentProperty = _ref.currentProperty,
    triggerRefresh = _ref.triggerRefresh,
    newPropertyCallback = _ref.newPropertyCallback;
  // const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  // const store = useStore();

  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => callback({
      action: 'cancel'
    }),
    isOpen: externalIsOpen,
    title: t('portfolios_properties_page.assign_properties_to_portfolio'),
    subTitle: subTitle,
    variant: "staticHeight",
    noFooter: true,
    noPadding: true,
    noLeftButton: true
  }, /*#__PURE__*/React.createElement(GetForm, {
    key: "AssignPropertiesToPortfolioModalForm",
    triggerRefresh: triggerRefresh,
    currentProperty: currentProperty,
    callback: callback,
    newPropertyCallback: newPropertyCallback,
    externalPortfolioItem: externalPortfolioItem,
    propertiesIds: externalPortfolioItem === null || externalPortfolioItem === void 0 ? void 0 : externalPortfolioItem.propertiesIds,
    propertyAddress: subTitle
  }));
});